import { nanoid } from 'nanoid'
import React from 'react'
import { checkTextTranslation, checkTranslation, setObject, translate } from '../../utils/useful'
import FormViewer from '../FormViewer'
import { apisList } from '../../variables/config'
import { index } from 'd3'


class ApisInput extends React.Component {
    state = {
        choiceOption: [
            {}
        ],
        firtRow: { title: '', value: nanoid() },
        fields: [

            { key: 'name', type: 'TextInput', information: { isSearchable: true, label: '{{lang}}Reference name', hint: "{{lang}}The fetched value can be recalled in the page using this name.", required: true }, },
            { key: 'collection', type: 'AdvancedMultiTreeSelect', information: { isSearchable: true, label: '{{lang}}Collection', address: 'getFramesApplet', filter: { appletPopulate: true }, fields: { title: 'name', value: '_id', image: 'image', mainParent: 'applet', parent: 'parents', type: 'type' }, type: 'api', placeholder: '{{lang}}Select Collection', required: true }, },
            // { key: 'API', type: 'SelectInput', information: { label: '{{lang}}API', type: 'local', items: [], placeholder: '{{lang}}select', required: true } },
            // { key: 'Filter', type: 'FilterEditorInput', information: { label: '{{lang}}Filter',inputClass:'bordered-input', placeholder: '{{lang}}select', required: true } },

        ]
    }


    componentDidMount() {

        // let apis = []

        // Object.entries(apisList)?.map(([key, value]) => {
        //     if (value.features) {
        //         let api = value
        //         api.value = key
        //         api.title = value.label
        //         apis.push(api)
        //     }
        // })

        // this.setState({ apis })

        // if (!this.props.data || this.props.data.length == 0) {
        //     this.addHandler()
        // }
    }

    changeInputValue(value) {
        this.props.changeValue(this.props.header.key, value, this.props.extra)

    }

    addHandler = () => {
        let data = this.props.data ?? []
        data.push({ value: nanoid() })
        this.changeInputValue(data)
    }


    removeHandler = (index) => {
        let data = this.props.data
        let indexx = index
        // let y=data.index[indexx]
        // console.log('eeeeeeee', index);
        // if (data.length < 2) {
        //     alert('nooooo')
        // } else {
        data.splice(index, 1)
        this.changeInputValue(data)
        // }
    }

    changeRowValue = (key, value, index) => {

        // console.log("changeRowValue")
        let data = this.props.data

        if (!Array.isArray(data)) {
            data = [{}]
        }
        // console.log(value)
        // data[index].title = value
        setObject(data[index], key, value)
        console.log(data)
        this.changeInputValue(data)
    }


    liveChange = (data, init, key, value, extra, full) => {

        if (!init && (extra?.index != null)) {
            this.changeRowValue(key, value, extra.index)
        }
    }



    render() {


        let variables = this.props.variables
        let params = [
            // { type: 'path', key: '1233', label: 'name', required: true },
            // { type: 'query', key: '234', label: 'id' },
            // { type: 'query', key: 'age', label: 'age' },

        ]

        let queryParams = params ? params.filter((a) => { return a.type == 'query' }) : []

        // if (params.filter((a) => { return a.type == 'query' }).length > 0) {
        //     hasQueryParam = true
        // }

        return (
            <div className=''>
                <div className='modern-input flexc flex-wrap'>
                    <p className='text-smaller opacity-5'><span>https://yonnect.com/{variables?.hub?.username}/</span>{variables?.applet?.slug}/</p>
                    <p className='text-small'><button className='br-4 px-1 py-0 mx-1' style={{ background: '#ddd' }}>{variables.page?.slug ?? variables.page?._id}</button>
                        {params && params.map((param, index) => {
                            if (param.type == 'path')
                                return (
                                    <span>
                                        /<button className='br-4 px-1 py-0 mx-1' style={{ background: '#ddd' }}>{param.label}</button>
                                    </span>
                                )
                        })}
                        {/* {hasQueryParam && (
                            <span>?</span>
                        )} */}
                        {queryParams && queryParams.map((param, index) => {
                            // if (param.type == 'query')
                            return (
                                <span>
                                    {index == 0 ? '?' : '&'}<button className='br-4 px-1 py-0 mx-1' style={{ background: '#ddd' }}>{param.label} = {"< " + param.label + " >"}</button>
                                </span>
                            )
                        })}

                    </p>
                </div>
                {/* {Array.isArray(list) && list.map((item, index) => {
                    return (
                        <div className="w-100 flexc flex-column pt-3" style={{ borderBottom: '1px solid #eee' }}>
                            <FormViewer ref={el => this.form = el} initData={item} headers={this.state?.fields} formClass="modern" inputClass={'modern-input'} liveChange={this.liveChange} extra={{index}} />
                            <div className='w-100 px-3 mb-3 flexce'>
                                <button style={{ color: '#ee5050' }} onClick={() => this.removeHandler(index)}>
                                    <p>{translate('Remove Row')}</p>
                                </button>
                            </div>
                        </div>
                    )
                })} */}
                <div className='px-2 py-1'>
                    

                    <button className='mrd-5' onClick={() => this.addHandler()}>
                        <p className='text-smaller' style={{ color: '#007aff' }}>{translate("Edit page slug")}</p>
                    </button>

                    <button className='mrd-3' onClick={() => this.addHandler()}>
                        <p className='text-smaller' style={{ color: '#007aff' }}>+ {translate("Add dynamic Param")}</p>
                    </button>

                </div>
            </div>
        );
    }
}

export default ApisInput;